<template>
  <div id="sellerList">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="微信昵称">
        <el-input
          size="mini"
          placeholder="微信昵称"
          prefix-icon="el-icon-search"
          v-model="searchForm.nickName"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="用户姓名">
        <el-input
          size="mini"
          placeholder="用户姓名"
          prefix-icon="el-icon-search"
          v-model="searchForm.userName"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          size="mini"
          placeholder="手机号"
          prefix-icon="el-icon-search"
          v-model="searchForm.phone"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="地区筛选">
        <el-cascader
          size="mini"
          v-model="searchForm.provinceAndCity"
          :options="provinceAndCityOption"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="用户等级">
        <el-select
          style="width: 100px"
          size="mini"
          v-model="searchForm.levelName"
          placeholder="请选择"
        >
          <el-option
            v-for="item in creditLevelList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册时间">
        <el-date-picker
          style="width: 250px"
          size="mini"
          v-model="searchForm.times"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          size="mini"
          placeholder="请输入备注"
          prefix-icon="el-icon-search"
          v-model="searchForm.notes"
        >
        </el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords"
        >
        </el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button size="mini" @click="exportToExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <common-table
      ref="ctable"
      :searchForm="searchForm"
      :api="table.api"
      :rowAction="table.rowAction"
      :batchAction="table.batchAction"
      :column="table.column"
      :callback="table.callback"
    >
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="blackListOperate(scope.rowData)"
          type="text"
          size="small"
        >
          {{ scope.rowData.black ? "移除黑名单" : "加入黑名单" }}
        </el-button>
        <el-button
          @click.native.prevent="viewSeller(scope.rowData)"
          type="text"
          size="small"
        >
          查看
        </el-button>
        <el-button
          @click.native.prevent="deleteSeller(scope.rowData)"
          type="text"
          size="small"
        >
          删除
        </el-button>
        <el-button
          @click.native.prevent="noteSeller(scope.rowData)"
          type="text"
          size="small"
        >
          备注
        </el-button>
      </template>
    </common-table>
    <el-dialog title="用户信息" :visible.sync="viewDialogVisible" width="50%">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="用户信息" name="first">
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">微信昵称</el-col>
            <el-col :span="8">{{ seller ? seller.nickname : "" }}</el-col>
            <el-col :span="4">用户头像</el-col>
            <el-col :span="8">
              <el-avatar
                size="small"
                :src="seller ? seller.headPic : defaultHeadPicSrc"
              ></el-avatar>
            </el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">APPID</el-col>
            <el-col :span="8"></el-col>
            <el-col :span="4">注册时间</el-col>
            <el-col :span="8">{{seller ? dateFormatter(null, null, seller.registDate) : ""}}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">手机号</el-col>
            <el-col :span="8">{{ seller ? seller.phone : "" }}</el-col>
            <el-col :span="4">姓名</el-col>
            <el-col :span="8">{{ seller.sellerName }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">生日</el-col>
            <el-col :span="8">{{
              seller ? dateFormatter(null, null, seller.birthday) : ""
            }}</el-col>
            <el-col :span="4">性别</el-col>
            <el-col :span="8">{{
              seller ? seller.sex : ""
            }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">邮箱</el-col>
            <el-col :span="8">{{ seller ? seller.email : "" }}</el-col>
            <el-col :span="4">身份证</el-col>
            <el-col :span="8">{{ seller ? seller.idCard : "" }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">身份证有效期</el-col>
            <el-col :span="8">{{
              seller.realnameValid ? seller.realnameValid.validdata : ""
            }}</el-col>
            <el-col :span="4">核验图片</el-col>
            <el-col :span="8">
              <img
                v-if="seller.realnameValid"
                :src="seller.realnameValid.handPic"
                style="width: 80px; height: auto"
              />
            </el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">联系地址</el-col>
            <el-col :span="20">{{seller.address}}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">所在单位</el-col>
            <el-col :span="8">{{seller.company}}</el-col>
            <el-col :span="4">用户等级</el-col>
            <el-col :span="8">{{seller.creditLevelName}}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">银行卡户名</el-col>
            <el-col :span="8">{{
              seller && seller.accountinfo ? seller.accountinfo.bankAccount : ""
            }}</el-col>
            <el-col :span="4">账号</el-col>
            <el-col :span="8">{{
              seller && seller.accountinfo ? seller.accountinfo.bankCardNum : ""
            }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">开户行</el-col>
            <el-col :span="8">{{
              seller && seller.accountinfo ? seller.accountinfo.bankName : ""
            }}</el-col>
            <el-col :span="4">网点</el-col>
            <el-col :span="8"></el-col>
          </el-row>
          <!-- <el-row :gutter="24" style="display: flex">
            <el-col :span="4">支付宝户名</el-col>
            <el-col :span="8"></el-col>
            <el-col :span="4">账号</el-col>
            <el-col :span="8"></el-col>
          </el-row> -->
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">推荐人手机</el-col>
            <el-col :span="8">{{ seller.referPhone }}</el-col>
            <el-col :span="4">用户来源</el-col>
            <el-col :span="8">{{ seller ? seller.source : "" }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">推荐人</el-col>
            <el-col :span="20">{{ seller.referrer }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">自定义等级</el-col>
            <el-col :span="8">{{ seller.disability }}</el-col>
            <el-col :span="4">婚姻状况</el-col>
            <el-col :span="8">{{ seller.marriage=='0'?'未婚':'已婚' }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">监护人</el-col>
            <el-col :span="8">{{ seller.guarder }}</el-col>
            <el-col :span="4">监护人手机</el-col>
            <el-col :span="8">{{ seller.guarderPhone }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: none">
            <el-col :span="4">个人介绍</el-col>
            <el-col :span="20">{{
              seller ? seller.selfIntroduction : ""
            }}</el-col>
          </el-row>
          <el-row :gutter="24" style="display: flex">
            <el-col :span="4">备注信息</el-col>
            <el-col :span="20">{{
              seller ? seller.notes : ""
            }}</el-col>
          </el-row>
          <!-- <el-row :gutter="24" style="display: flex">
            <el-col :span="24"> <h4>自定义字段</h4></el-col>
          </el-row> -->
        </el-tab-pane>
        <el-tab-pane label="出售订单" name="second">
          <el-row :gutter="24">
            <el-col :span="6">累计出售数量:</el-col>
            <el-col :span="6">{{ orderInfo.obj.numCount }}</el-col>
            <el-col :span="6">累计出售金额:</el-col>
            <el-col :span="6">{{ orderInfo.obj.moneyCount }}元</el-col>
          </el-row>
          <el-table
            max-height="500px"
            :data="orderInfo.list"
            style="width: 100%"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="orderNum" label="订单号"></el-table-column>
            <el-table-column
              prop="cardName"
              label="商品名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="payMoney"
              label="金额（元）"
            ></el-table-column>
            <el-table-column
              prop="actualPay"
              label="实际金额（元）"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
              :formatter="dateFormatter"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="status" label="订单状态"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="信用积分" name="third">
          <el-row :gutter="24">
            <el-col :span="8">累计信用积分:</el-col>
            <el-col :span="4">
              {{ creditInfo.obj.creditTotal }}
              <el-button
                @click.native.prevent="changeCreditPoint()"
                type="text"
                size="small"
              >
                修改
              </el-button>
            </el-col>
            <el-col :span="6">信用等级:</el-col>
            <el-col :span="6">{{ creditInfo.obj.creditLevelName }}</el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">累计免审信用额（元）:</el-col>
            <el-col :span="4">{{ creditInfo.obj.creditLimitTotal }}</el-col>
            <el-col :span="12" style="color: #999"
              >备注：累计免审信用额=系统信用额+人工调整额</el-col
            >
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">系统信用额度（元）:</el-col>
            <el-col :span="4">{{ creditInfo.obj.creditLimitSys }}</el-col>
            <el-col :span="6">人工调整额（元）:</el-col>
            <el-col :span="6">
              <span v-if="!changeLimitHandFlag">{{
                creditInfo.obj.creditLimitHand
              }}</span>
              <el-input
                v-if="changeLimitHandFlag"
                v-model="creditInfo.obj.creditLimitHand"
                placeholder="请输入内容"
              ></el-input>
              <el-button
                v-if="!changeLimitHandFlag"
                @click.native.prevent="changeCreditLimitHand(creditInfo.obj.id)"
                type="text"
                size="small"
              >
                修改
              </el-button>
              <el-button
                v-if="changeLimitHandFlag"
                @click.native.prevent="
                  changeCreditLimitHandSure(creditInfo.obj.id)
                "
                type="text"
                size="small"
              >
                保存
              </el-button>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">剩余可用额度（元）:</el-col>
            <el-col :span="4">{{ creditInfo.obj.creditLimitSurplus }}</el-col>
          </el-row>
          <el-table
            max-height="500px"
            :data="creditInfo.list"
            style="width: 100%"
          >
            <el-table-column type="index" label="NO"></el-table-column>
            <el-table-column prop="ruleWorkWay" label="项目"></el-table-column>
            <el-table-column
              prop="getTime"
              label="时间"
              :formatter="dateFormatter"
            ></el-table-column>
            <el-table-column
              prop="creditChange"
              label="信用积分变动"
            ></el-table-column>
            <el-table-column
              prop="totalCredits"
              label="累计积分"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="fourth">
          <el-row :gutter="20">
            <el-col :span="8">累计已提现（元）:</el-col>
            <el-col :span="4">{{
              (payLimit.limitTotal / 100).toFixed(2)
            }}</el-col>
            <el-col :span="8">每日提现开关:</el-col>
            <el-col :span="4">
              <el-switch
                v-model="payLimit.isWork"
                @change="changePayLimitWork"
                active-color="#13ce66"
                :inactive-value="'0'"
                :active-value="'1'"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-col>
            <el-col :span="8">日提现总限额:</el-col>
            <el-col :span="4">
              {{ payLimit.dailyLimit }}
              <el-button type="text" @click="handleChangePayLimit"
                >修改</el-button
              >
            </el-col>
            <el-col :span="8">当日已提现额度:</el-col>
            <el-col :span="4">{{
              (payLimit.dailyLimitUsed / 100).toFixed(2)
            }}</el-col>
          </el-row>
          <el-table max-height="500px" :data="walletList" style="width: 100%">
            <el-table-column type="index" label="NO"></el-table-column>
            <el-table-column prop="amount" label="提现金额">
              <template slot-scope="scope">
                {{ (scope.row.amount / 100).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="paymentTime"
              label="提现时间"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="paymentNo"
              label="微信付款单号"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="partnerTradeNo"
              label="商户订单号"
              show-overflow-tooltip
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="会员付费" name="five">
          <el-table
            :data="vipPayMounthTableData"
            stripe border
            style="width: 100%"
            max-height="500px"
          >
            <el-table-column
              label="序号"
              width="50"
              prop="index"
            ></el-table-column>
            <el-table-column
              prop="orderNum"
              label="订单号"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="cardName"
              label="购买时长(月)"
            ></el-table-column>
            <el-table-column
              prop="actualPay"
              label="金额(元)"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="订单状态"
              width="120"
            ></el-table-column>
            <el-table-column label="退款金额" width="120"></el-table-column>
            <el-table-column label="扣除有效期天" width="120"></el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
              width="180"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="购买订单" name="sex">
          <el-table
            :data="vipPayTableData"
            stripe border
            style="width: 100%"
            max-height="500px"
          >
            <el-table-column
              label="序号"
              width="50"
              prop="index"
            ></el-table-column>
            <el-table-column
              prop="orderNum"
              label="订单号"
              width="150"
            ></el-table-column>
            <el-table-column prop="cardName" label="文章标题"></el-table-column>
            <el-table-column
              prop="actualPay"
              label="金额(元)"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="订单状态"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
              width="180"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="康复订单" name="seventh">
          <div>累计康复订单数：{{kangfuTableTotal.totalCount}}<span style="padding-left:30px"></span>累计消费金额：{{kangfuTableTotal.totalConsume}}</div>
          <p style="color:rgb(76,0,255);">点击订单号可查看订单详情</p>
          <el-table
            :data="kangfuTableData"
            stripe border
            style="width: 100%"
            max-height="500px"
            @cell-click="kangfuTabelCellClick"
          >
            <el-table-column
              label="序号"
              width="50"
              prop="index"
            ></el-table-column>
            <el-table-column
              prop="orderNum"
              label="订单号"
              width="150"
            ></el-table-column>
            <el-table-column prop="serviceName" label="服务名称"></el-table-column>
            <el-table-column prop="serviceAgentName" label="门店"></el-table-column>
            <el-table-column prop="servicerName" label="服务人员"></el-table-column>
            <el-table-column prop="userName" label="服务对象"></el-table-column>
            <el-table-column
              prop="wxpayMoney"
              label="金额(元)"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="appointTime"
              label="预约时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="statusName"
              label="订单状态"
              width="120"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="康复档案" name="eighth">
          <el-row v-for="(row,index) in seller.kangfu" :gutter="24" style="display: flex" :key="index">
              <el-col :span="4">{{row[0]}}</el-col>
              <el-col :span="8">{{ row[1] }}</el-col>
              <el-col :span="4">{{row[2]}}</el-col>
              <el-col :span="8">{{ row[3] }}</el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="用户备注" :visible.sync="showNotes" width="50%">
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容,30个字符以内"
        maxlength="30"
        v-model="notes"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSellerNotes()">取 消</el-button>
        <el-button type="primary" @click="saveSellerNotes">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改用户积分" :visible.sync="showChangePoint" width="50%">
      <el-input-number
        v-model="changePoint"
        label="请输入修改积分，整数为加负数为减"
      ></el-input-number>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangePoint()">取 消</el-button>
        <el-button type="primary" @click="saveChangePoint">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改用户每日提现限额"
      :visible.sync="showChangePayLimit"
      width="50%"
    >
      <el-input-number
        v-model="payLimit.dailyLimit"
        label="请输入每日提现限额"
      ></el-input-number>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeChangePayLimit()">取 消</el-button>
        <el-button type="primary" @click="saveChangePayLimit">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="站内通知" :visible.sync="showSysNotice" width="50%">
      <el-input placeholder="请输入通知标题" v-model="sysNoticeTitle">
      </el-input>
      <p></p>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入通知内容"
        v-model="sysNoticeContent"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSysNotice()">取 消</el-button>
        <el-button type="primary" @click="saveSysNotice">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量导入"
      :visible.sync="uploadDialog.visible"
      width="50%"
      @open="uploadDialog.fileList=[]"
    >
      <el-upload
        class="upload-demo"
        action="api/seller/importUserSample"
        :limit="1"
        accept=".xlsx"
        :file-list="uploadDialog.fileList"
        :on-success="uploadDialog.handleSuccess"
        :before-upload="uploadDialog.beforeUpload"
        :on-error="uploadDialog.handleError"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xlsx文件
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="uploadDialog.loading" @click="uploadDialog.visible=false">关闭</el-button>
      </span>
    </el-dialog>
    
    <el-dialog
      title="订单详情"
      width="70%"
      :visible.sync="detailDialog.visible"
      @closed="detailDialog.data = {};detailDialog.fileList=[]"
    >
    <detail :detail="detailDialog"></detail>
    </el-dialog>
  </div>
</template>

<script>
import { CodeToText, provinceAndCityDataPlus } from "element-china-area-data";
import utils from "../utils/utils";
import axios from "axios";
import detail from './schedule/order_detail.vue'
import commonTable from "./plugin/common-table.vue";
import qs from "qs";
export default {
  components: { commonTable,detail },
  name: "seller-list",
  data() {
    return {
      fileList:[],
      uploadDialog: {
        visible: false,
        fileList:[],
        loading:false,
        handleSuccess:()=>{
          this.uploadDialog.loading = false;
        },
        beforeUpload:()=>{
          this.uploadDialog.loading = true;
        },
        handleError:()=>{
          this.uploadDialog.loading = false;
        }
      },
      table: {
        api: "api/seller/query",
        callback: (res, data) => {
          data.forEach((item) => {
            item.address =`${item.province||''}${item.city||''}${item.county||''}${item.town||''}${item.detailAddress||''}`;
            let sex = '未知'
            if(item.sex=='1'){
              sex = '男'
            }
            if(item.sex=='2'){
              sex = '女'
            }
            item.sex = sex
          });
        },
        rowAction: { label: "操作", width: 120, fixed: "right" },
        batchAction: [
          { text: "添加会员", action: this.gotoAdd, type: "primary" },
          { text: "批量导入", action: this.importFromExcel, type: "primary" },
          { text: "导出", action: this.exportToExcel },
          { text: "站内通知", action: this.sendSysNotice },
          { text: "样表导出", action: this.exportTemp },
        ],
        column: [
          {
            label: "微信昵称",
            name: "nickname",
            width: 150,
            extend: { name: "headPic", type: "avatar" },
          },
          { label: "姓名", name: "sellerName" },
          { label: "地区", name: "address" },
          { label: "手机号", name: "phone", width: 80 },
          { label: "等级名称", name: "creditLevelName" },
          { label: "信用积分", name: "creditPoint"},
          { label: "钱包余额", name: "a",},
          { label: "消费金额", name: "b"},
          { label: "下单权限", name: "orderAuthority",type: "switch",action:(row)=>{
            this.$httpRequest.get(`/api/seller/enableOrderAuthority?sellerId=${row.id}&status=${row.orderAuthority==1?2:1}`)
            this.$refs.ctable.getData();
          }
          },
          {
            label: "注册时间",
            name: "registDate",
            formatter: this.dateFormatter,
          },
          { label: "备注", name: "notes" },
        ],
      },
      creditLevelList: [],
      showChangePoint: false,
      changePoint: null,
      provinceAndCityOption: provinceAndCityDataPlus,
      searchForm: {
        levelName: "",
        times: [],
        provinceAndCity: [],
        nickName: "",
        userName:"",
        phone:"",
        notes: "",
      },
      detailDialog: {
        visible: false,
        loading: false,
        data: {},
        formData:[],
        evalData:{}
      },
      tableData: [],
      vipPayMounthTableData: [],
      vipPayTableData: [],
      kangfuTableData:[],
      kangfuTableTotal:{totalCount:0,totalConsume:0},
      pageInfo: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      viewDialogVisible: false,
      activeName: "first",
      seller: {},
      defaultHeadPicSrc: require("../assets/person.png"),
      multipleSelection: [],
      statusObj: [
        { status: "0", name: "全部", showTab: true },
        { status: "4", name: "待支付", showTab: false },
        { status: "10", name: "已退款", showTab: true },
        { status: "6", name: "已完成", showTab: true },
      ],
      creditInfo: {
        list: [],
        obj: {
          id: null,
          creditLevelName: "",
          creditLimitHand: 0,
          creditLimitSurplus: 0,
          creditLimitSys: 0,
          creditLimitTotal: 0,
          creditTotal: 0,
        },
      },
      changeLimitHandFlag: false,
      orderInfo: {
        list: [],
        obj: {
          numCount: 0,
          moneyCount: 0,
        },
      },
      notes: "",
      showNotes: false,
      sellerId: null,
      walletList: [],
      showSysNotice: false,
      sysNoticeTitle: "",
      sysNoticeContent: "",
      payLimit: {
        isWork: "0",
        limitTotal: 0,
        dailyLimit: 100,
        dailyLimitUsed: 100,
      },
      showChangePayLimit: false,
    };
  },
  created() {
    this.queryLevelAll();
  },
  methods: {
    gotoAdd() {
      this.$router.push("/add-seller");
    },
    importFromExcel() {
      this.uploadDialog.visible = true;
    },
    //获取用户信用等级
    queryLevelAll() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/creditManage/queryLevelAll",
        callback: (res) => {
          this.creditLevelList = res.data.list;
        },
      });
    },
    //查询
    onSearch() {
      if (this.searchForm.times && this.searchForm.times.length > 0) {
        this.searchForm.registerStart = this.searchForm.times[0];
        this.searchForm.registerEnd = this.searchForm.times[1];
      }
      if (
        this.searchForm.provinceAndCity &&
        this.searchForm.provinceAndCity.length > 0
      ) {
        this.searchForm.province = this.searchForm.provinceAndCity[0];
        this.searchForm.city = this.searchForm.provinceAndCity[1];
      }
      this.$refs.ctable.getData();
    },
    kangfuTabelCellClick(row, column, cell, event){
      if(column.property == 'orderNum'){
        this.showDetail(row);
      }
    },
    showDetail(data) {
      this.detailDialog.visible = true;
      this.detailDialog.loading = true;
      this.$httpRequest.get('api/serviceOrder/getRelatedFormList',{orderId:data.id,pageSize:1000,currentPage:1}).then(res=>{
        this.detailDialog.formData = res.data.list;
      })
      
        let orderStu={
          '0':'待派单',
          '1':'已派单',
          '2':'上门中',
          '3':'服务中',
          '4':'已完成',
          '5':'已取消',
          '6':'退单审核中',
          '10':'待支付',
          '11':'退款中',
          '12':'已退款',
        }
      this.$httpRequest
        .get("api/serviceOrder/getOrderDetail?orderId=" + data.id)
        .then((res) => {
          this.detailDialog.data = res.data.obj;
          this.detailDialog.data.status = orderStu[res.data.obj.status];
          this.detailDialog.fileList=[];
          if(res.data.obj.orderData){
            res.data.obj.orderData.split(';').forEach(od=>{
              const index = od.lastIndexOf('/')+1
              this.detailDialog.fileList.push({
                name:od.substring(index),
                url:od
              })
            })
          }
          this.$httpRequest.get("api/serviceOrder/getOrderEval?orderId=" + data.id).then(res=>{
            if(res.data.list && res.data.list.length>0){
              this.detailDialog.evalData=res.data.list;
              this.detailDialog.evalData.forEach(item=>{
                item.isShow = item.isShow=='1'
                if(item.imgUrls){
                  item.imgUrls = item.imgUrls.split(',')
                }
                item.createTime = util.dateFormat( item.createTime,"yyyy-MM-dd HH:mm")
              })
              var t = this.detailDialog.evalData.filter(x=>x.sellerId)
              if(t&&t.length>0){
                this.detailDialog.lastEval= t[t.length-1];
              }
            }
          })
          this.detailDialog.loading = false;
        })
        .catch((e) => (this.detailDialog.loading = false));
    },
    handleSuccess(response, file, fileList){
      const i = response.lastIndexOf('/')+1
      file.name=response.substring(i);
      let orderData = `${this.detailDialog.data.orderData};${response}`;
      if(!this.detailDialog.data.orderData){
        orderData = response;
      }
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData",{orderId:this.detailDialog.data.id,orderData:orderData})
        .then((res) => {
          this.$message.success('上传成功')
        }).catch(()=>{
          this.$message.error('上传失败')
          const index = fileList.indexOf(file);
          fileList.splice(index,1)
        })
    },
    removeInServer(file,fileList){
      const orderData = fileList.filter(f=>f!=file).map(f=>f.url).join(';')
      this.$httpRequest
        .post("api/serviceOrder/commitOrderData",{orderId:this.detailDialog.data.id,orderData:`${orderData}`})
        .then((res) => {
          this.$message.success('删除成功')
          this.detailDialog.data.orderData = orderData;
          const index = fileList.indexOf(file);
          fileList.splice(index,1)
        }).catch(()=>{
        })
      return false;
    },
    
    submitRemark(){
      this.$message.error('缺少提交备注接口')
    },
    
    downloadFile(file){
      console.log(file)
      window.open(
        file.url,
        "_brank"
      );
    },
    exportTemp() {
      window.open(
        "http://pic.mumetech.com/1655624792862_附件1.1用户批量导入表V2-zxl20220617.xlsx",
        "_parent"
      );
    },
    //导出
    exportToExcel() {
      const exportData = this.$refs.ctable.getMultipleSelection();
      window.open(
        "/api/seller/exportToExcel?ids=" +
          exportData.map((s) => s.id).join(","),
        "_parent"
      );
    },
    //查看
    viewSeller(row) {
      this.sellerId = row.id;
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0)",
      });
      this.seller = Object.assign({}, row);
      if(this.seller.userDefSetting){
        const kangfu = JSON.parse(this.seller.userDefSetting)
        const keys = Object.keys(kangfu)
        const rows = Math.ceil(keys.length/2)
        this.seller.kangfu = []
        for(let r =0;r<rows;r++){
          let key1 =keys[(2*r)],key2=keys[(2*r+1)]
          this.seller.kangfu[r] = [key1,kangfu[key1],key2,kangfu[key2]]
        }
      }
      
      this.activeName = "first"
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/getCreditInfo",
        params: {
          id: row.id,
        },
        callback: (res) => {
          loading.close();
          this.viewDialogVisible = true;
          this.creditInfo = res.data;
        },
        catch: (err) => {
          loading.close();
        },
      });
      utils.axiosMethods({
        method: "GET",
        url: "/api/order/queryOrderBySellerId",
        params: {
          sellerId: row.id,
        },
        callback: (res) => {
          loading.close();
          this.viewDialogVisible = true;
          this.orderInfo = res.data;
        },
        catch: (err) => {
          loading.close();
        },
      });

      utils.axiosMethods({
        method: "GET",
        url: "/api/shop/getTransfersRecordBySellerId",
        params: {
          sellerId: row.id,
        },
        callback: (res) => {
          loading.close();
          this.viewDialogVisible = true;
          this.walletList = res.data.list;
        },
        catch: (err) => {
          loading.close();
        },
      });
      utils.axiosMethods({
        method: "GET",
        url: "/api/seller/getSellerPayLimit",
        params: {
          sellerId: row.id,
        },
        callback: (res) => {
          loading.close();
          this.viewDialogVisible = true;
          this.payLimit = res.data.obj;
        },
        catch: (err) => {
          loading.close();
        },
      });

      this.$httpRequest
        .post(
          "/api/order/queryArticleOrder?" +
            qs.stringify({ currentPage: 1, pageSize: 500 }),
          { sellerName: row.nickname }
        )
        .then((res) => {
          this.vipPayTableData = res.data.list.map((element, index) => {
            element.index = index + 1;
            element.statusName = element.status;
            element.createTime = utils.dateFormat(
              element.createTime,
              "yyyy-MM-dd HH:mm:ss"
            );
            this.statusObj.forEach((item) => {
              if (item.status == element.status && element.status != 0) {
                element.statusName = item.name;
              }
            });
            return element;
          });
        })
        .catch((e) => {
          console.log(e);
        });

      this.$httpRequest
        .post(
          "/api/order/queryOrder?" +
            qs.stringify({ currentPage: 1, pageSize: 500 }),
          { searchType: "order", keyWord: row.nickname }
        )
        .then((res) => {
          this.vipPayMounthTableData = res.data.list.map((element, index) => {
            element.index = index + 1;
            element.statusName = element.status;
            this.statusObj.forEach((item) => {
              if (item.status == element.status && element.status != 0) {
                element.statusName = item.name;
              }
            });
            return element;
          });
        })
        .catch((e) => {
          console.log(e);
        });
        let orderStu={
          '0':'待派单',
          '1':'已派单',
          '2':'上门中',
          '3':'服务中',
          '4':'已完成',
          '5':'已取消',
          '6':'退单审核中',
          '10':'待支付',
          '11':'退款中',
          '12':'已退款',
        }
        this.$httpRequest
        .get(
          "/api/serviceOrder/getNursingOrderByUserId?" +
            qs.stringify({ currentPage: 1, pageSize: 500,userId:row.id })
        )
        .then((res) => {
          this.kangfuTableTotal = res.data.obj;
          this.kangfuTableData = res.data.list.map((element, index) => {
            element.index = index + 1;
            element.statusName = orderStu[element.status];
            element.appointTime = utils.dateFormat(
              element.appointTime,
              "yyyy-MM-dd HH:mm:ss"
            );
            return element;
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //删除
    deleteSeller(row) {
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/deleteById",
        params: {
          id: row.id,
        },
        callback: (res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "恭喜你，删除成功",
              type: "success",
            });
            this.getData();
          }
        },
      });
    },
    //每页展示数据条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData();
    },
    //页码改变
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getData();
    },
    handleTabClick() {},
    // 日期格式化
    dateFormatter(row, column, cellValue, index) {
      return utils.dateFormat(cellValue);
    },
    // 省市显示中文
    codeToText(str) {
      return str != null && str != "" ? CodeToText[str] : "";
    },
    // 手动修改额度
    changeCreditLimitHand(id) {
      this.changeLimitHandFlag = true;
    },
    //手动修改额度保存
    changeCreditLimitHandSure(id) {
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/changeCreditLimitHand",
        params: {
          id: id,
          creditNum: this.creditInfo.obj.creditLimitHand,
        },
        callback: (res) => {
          this.changeLimitHandFlag = false;
          this.creditInfo.obj.creditLimitTotal =
            parseFloat(this.creditInfo.obj.creditLimitHand) +
            parseFloat(this.creditInfo.obj.creditLimitSys);
          this.$message({
            message: "恭喜你，修改成功",
            type: "success",
          });
        },
      });
    },
    noteSeller(row) {
      this.notes = row.notes;
      this.showNotes = true;
      this.sellerId = row.id;
    },
    saveSellerNotes() {
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/updateSellerNotes",
        data: {
          id: this.sellerId,
          notes: this.notes,
        },
        callback: (res) => {
          this.showNotes = false;
          this.getData();
          this.$message({
            message: "恭喜你，修改成功",
            type: "success",
          });
        },
      });
    },
    closeSellerNotes() {
      this.showNotes = false;
      this.sellerId = null;
    },
    blackListOperate(row) {
      if (row.black) {
        utils.axiosMethods({
          method: "GET",
          url: "/api/seller/removerFromBlackList",
          params: {
            id: row.id,
          },
          callback: (res) => {
            this.getData();
            this.$message({
              message: "移除黑名单成功",
              type: "success",
            });
          },
        });
      } else {
        utils.axiosMethods({
          method: "GET",
          url: "/api/seller/joinToBlackList",
          params: {
            id: row.id,
            name: row.name,
          },
          callback: (res) => {
            this.getData();
            this.$message({
              message: "加入黑名单成功",
              type: "success",
            });
          },
        });
      }
    },
    // 手动修改用户积分
    changeCreditPoint() {
      this.showChangePoint = true;
    },
    closeChangePoint() {
      this.showChangePoint = false;
    },
    closeChangePayLimit() {
      this.showChangePayLimit = false;
    },
    closeSysNotice() {
      this.showSysNotice = false;
    },
    saveChangePoint() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/seller/insertCreditPoint",
        params: {
          sellerId: this.sellerId,
          point: this.changePoint,
        },
        callback: (res) => {
          this.showChangePoint = false;
          this.viewDialogVisible = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
        },
      });
    },
    saveChangePayLimit() {
      utils.axiosMethods({
        method: "GET",
        url: "/api/seller/insertDailyLimit",
        params: {
          sellerId: this.sellerId,
          limit: this.payLimit.dailyLimit,
        },
        callback: (res) => {
          this.showChangePayLimit = false;
          this.viewDialogVisible = false;
          this.$message({
            message: "修改成功",
            type: "success",
          });
        },
      });
    },
    sendSysNotice() {
      this.$refs.ctable.getMultipleSelection();
      this.showSendSysNoticeWin();
    },
    showSendSysNoticeWin() {
      this.showSysNotice = true;
    },
    handleChangePayLimit() {
      this.showChangePayLimit = true;
    },
    saveSysNotice() {
      const data = this.$refs.ctable.getMultipleSelection();
      utils.axiosMethods({
        method: "POST",
        url: "/api/seller/sendSysNotice",
        data: {
          ids: data.map((s) => s.id).join(","),
          title: this.sysNoticeTitle,
          content: this.sysNoticeContent,
        },
        callback: (res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.showSysNotice = false;
          } else {
            this.$message.error(res.data.msg);
          }
        },
      });
    },
    changePayLimitWork(val) {
      const isWork = val ? "1" : "0";
      utils.axiosMethods({
        method: "GET",
        url: "/api/seller/changeSellerPayLimitWork",
        params: {
          sellerId: this.sellerId,
          isWork: isWork,
        },
        callback: (res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.payLimit.isWork = isWork;
          } else {
            this.$message.error(res.data.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
#sellerList {
  .block {
    float: right;
    margin-top: 20px;
  }
  .el-tabs__content .el-row {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sellerList.vue